import { ViewContainerRef } from '@angular/core';
import { ITextRich } from 'src/app/api/modules/core/dynamic/components/ITextRich';
import { TextRichComponent } from './text-rich.component';

/**
 * Dynamically creates a `TextRich` instance
 * @param viewContainerRef the container into which we want to inject the component
 * @param config the configuration required to construct a valid component
 */
export const createTextRichComponent = (viewContainerRef: ViewContainerRef, config: ITextRich) => {
  const componentReference = viewContainerRef.createComponent(TextRichComponent);
  componentReference.setInput('config', config);
  return componentReference;
};
